import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
export default function AnimatedSquaresBackground({ squarePattern, className = '' }) {
    const ref = useRef(null);
    const containerRef = useRef(null);
    const { scrollYProgress } = useScroll({
        target: containerRef,
        offset: ['start end', 'end start']
    });
    return (React.createElement("div", { ref: containerRef, className: `absolute inset-0 overflow-hidden pointer-events-none ${className}` },
        React.createElement("div", { ref: ref, className: "absolute inset-0" }, squarePattern.map((group, index) => (React.createElement(motion.div, { key: `group-${index}`, className: "absolute", style: {
                left: `${group.x}%`,
                top: `${group.y}%`,
                y: useTransform(scrollYProgress, [0, 1], [0, group.parallaxSpeed])
            } }, group.squares.map((square, squareIndex) => (React.createElement(motion.div, { key: `group-${index}-square-${squareIndex}`, id: `group-${index}-square-${squareIndex}`, className: "absolute", style: {
                width: square.size,
                height: square.size,
                left: square.x,
                top: square.y,
                backgroundColor: square.color,
                rotate: square.rotate || 0
            }, initial: { opacity: 0 }, whileInView: { opacity: square.opacity }, transition: { opacity: { duration: 0.8 } } })))))))));
}
